<template>
    <div class="left_fixed">
        <div class="img_222 alter_box" @click="show_alter('login')" v-if="!user.account"></div>
        <div class="img_223 alter_box" @click="clear_cookie" v-else></div>
        <div class="img_15 alter_box" @click="show_alter('rule')"></div>
        <div class="img_16 alter_box" @click="show_alter('lottery_log')"></div>
        <div class="img_95 alter_box" @click="knapsack"></div>
    </div>
</template>

<script>
module.exports = {
    data() {
        return {
            user: {}
        }
    },
    created() {
        this.user=this.user_data
        console.log('user_data',this.user_data)
    },
    methods: {
        knapsack() {
            this.$emit('knapsack')
        },
        show_alter(type) {
            if (type != 'rule') {
                if (!this.user_data.account) {
                    type = 'login'
                }
            }
            this.$emit('alter', type)
        },
        clear_cookie() {
            this.user.account = null
            this.user.account = ''
            this.user.a_tel_shave = ''
            this.user.value = 0
            document.cookie = "a_tel=; expires=Sun, 31 Dec 2017 12:00:00 UTC;path=/;domain=.firewick.net;";
            document.cookie = "a_tel_shave=; expires=Sun, 31 Dec 2017 12:00:00 UTC;path=/;domain=.firewick.net;";
            this.$emit('init')
        },
    }
}
</script>

<style scoped>
.left_fixed {
    position: fixed;
    left: 50%;
    margin-left: -3.75rem;
    top: 1.2rem;
    z-index: 20;
}

.alter_box {
    cursor: pointer;
    margin-bottom: 0.2rem;
}
</style>